export interface SanitizedReturnUrl {
	url: string;
	isAbsolute: boolean;
}

function getAllowedRedirectOrigins() {
	const configuredUrls = [
		window.SAM._env_.REACT_APP_V2_BASE_URL,
		window.SAM._env_.REACT_APP_BASE_API_URL,
	];

	return configuredUrls.flatMap((configuredUrl) => {
		try {
			return [new URL(configuredUrl).origin];
		} catch {
			return [];
		}
	});
}

export function sanitizeReturnUrl(
	returnUrlParam: string | null | undefined
): SanitizedReturnUrl | null {
	if (!returnUrlParam) return null;
	if (returnUrlParam.startsWith("//")) return null;
	if (returnUrlParam.startsWith("/")) {
		return { url: returnUrlParam, isAbsolute: false };
	}

	try {
		const url = new URL(returnUrlParam, window.location.origin);

		if (url.origin === window.location.origin) {
			return {
				url: `${url.pathname}${url.search}${url.hash}`,
				isAbsolute: false,
			};
		}

		if (getAllowedRedirectOrigins().includes(url.origin)) {
			return { url: url.toString(), isAbsolute: true };
		}
	} catch {
		return null;
	}

	return null;
}
